export default __webpack_public_path__ + "static/image6-eb27b1edced6ab16487ee4ac137823dc.jpg";